import { render } from "./vant-table.vue?vue&type=template&id=6fa77305&scoped=true"
import script from "./vant-table.vue?vue&type=script&lang=js"
export * from "./vant-table.vue?vue&type=script&lang=js"

import "./vant-table.vue?vue&type=style&index=0&id=6fa77305&lang=less&scoped=true"

import exportComponent from "C:\\Users\\lq\\Desktop\\普康\\activity-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fa77305"]])

export default __exports__